import type { ReactNode } from 'react';
import styles from './FJBlankPanel.module.less';
import emptyBase64 from '../../../assets/base64/empty.js';
import FJImage from '../FJImage/FJImage';

export interface FJBlankPanelProps {
    text?: string;
    children?: ReactNode;
    textSuffix?: ReactNode;
}

export default function FJBlankPanel({ text, children, textSuffix }: FJBlankPanelProps) {
    return (
        <div className={styles.blank}>
            <FJImage
                imgSrc={emptyBase64}
                imgClassName={styles.blank_img}
                disableDefaultImgClass
                alt=''
                aria-hidden={true}
            />
            <span className={styles.blank_text}>
                {text}
                {textSuffix}
            </span>
            {children}
        </div>
    );
}
